import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import headerLandscapeImage from '../../assets/header-portrait.png';
import footerLandscapeImage from '../../assets/footer-portrait.png';

export async function generateFacultyWorkloadSummaryPDF(summaryData, options) {
    const [headerBase64, footerBase64] = await Promise.all([
        getBase64Image(headerLandscapeImage),
        getBase64Image(footerLandscapeImage),
    ]);

    const tableBody = [
        [
            { text: 'No.', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'NAME', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'EMPLOYMENT STATUS', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'TEACHING LOAD EQUIVALENT\n(Undergraduate)', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'TEACHING LOAD EQUIVALENT\n(Graduate)', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'ADMIN LOAD RELEASE', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'RDE Load Release', bold: true, alignment: 'center', fontSize: 10 },
            { text: 'TOTAL LOAD UNITS/WK', bold: true, alignment: 'center', fontSize: 10 },
        ]
    ];

    const sortedSummaryData = [];
    let facultyRows = [];
    let programHeader = null;
    
    function getSortLastName(row) {
        if (row.user && row.user.lname) return row.user.lname.toUpperCase();
        if (row.lname) return row.lname.toUpperCase();
        if (row.name) return row.name.toUpperCase();
        return '';
    }

    summaryData.forEach(row => {
        if (row.isProgram) {
            if (facultyRows.length > 0) {
                facultyRows.sort((a, b) => getSortLastName(a).localeCompare(getSortLastName(b)));
                facultyRows.forEach((f, idx) => f._sequentialNo = idx + 1);
                sortedSummaryData.push(...facultyRows);
                facultyRows = [];
            }
            sortedSummaryData.push(row);
            programHeader = row;
        } else {
            facultyRows.push(row);
        }
    });

    if (facultyRows.length > 0) {
        facultyRows.sort((a, b) => getSortLastName(a).localeCompare(getSortLastName(b)));
        facultyRows.forEach((f, idx) => f._sequentialNo = idx + 1);
        sortedSummaryData.push(...facultyRows);
    }

    sortedSummaryData.forEach(row => {
        if (row.isProgram) {
            tableBody.push([
                { text: row.program, bold: true, colSpan: 8, alignment: 'left', fontSize: 11, margin: [0, 3, 0, 3] },
                {}, {}, {}, {}, {}, {}, {}
            ]);
        } else {
            let formattedName = '';
            if (row.user && row.user.lname && row.user.fname) {
                formattedName = row.user.lname.toUpperCase() + ', ' + row.user.fname.toUpperCase();
                if (row.user.mname && row.user.mname.length > 0) {
                    formattedName += ' ' + row.user.mname[0].toUpperCase() + '.';
                }
            } else if (row.lname && row.fname) {
                formattedName = row.lname.toUpperCase() + ', ' + row.fname.toUpperCase();
                if (row.mname && row.mname.length > 0) {
                    formattedName += ' ' + row.mname[0].toUpperCase() + '.';
                }
            } else {
                formattedName = '';
            }
            tableBody.push([
                { text: row._sequentialNo, alignment: 'center', fontSize: 10 },
                { text: formattedName, alignment: 'left', fontSize: 10 },
                { text: row.employment_status, alignment: 'center', fontSize: 10 },
                { text: row.teaching_load_undergrad ?? '—', alignment: 'center', fontSize: 10 },
                { text: row.teaching_load_grad ?? '—', alignment: 'center', fontSize: 10 },
                { text: row.admin_load_release ?? '—', alignment: 'center', fontSize: 10 },
                { text: row.rep_load_release ?? '—', alignment: 'center', fontSize: 10 },
                { text: row.total_load_units ?? '—', alignment: 'center', fontSize: 10, bold: true },
            ]);
        }
    });

    const pageSize = { width: 612, height: 936 };

    const docDefinition = {
        defaultStyle: { font: "ArialNarrow" },
        pageSize: pageSize,
        pageOrientation: 'portrait',
        pageMargins: [35, 120, 35, 100],
        info: {
            title: options.instituteName + ' Faculty Workload Summary SY ' + options.schoolYear,
        },
        header: (currentPage, pageCount, pageSize) => {
            return {
                stack: [
                  {
                        image: headerBase64,
                        width: pageSize.width - 30,
                        alignment: 'center',
                        margin: [0, 10, 0, 0]
                  },
                  {
                        text: 'Office of the Vice President for Academic Affairs',
                        fontSize: 16,
                        bold: true,
                        alignment: 'center',
                        font: "CenturySchoolBook"
                    }
                ]
            };
        },
        footer: {
            image: footerBase64,
            width: pageSize.width - 30,
            alignment: 'center',
            margin: [0, 25, 0, 0]
        },
        content: [
            {
                text: `SUMMARY OF FACULTY WORKLOAD\n${options.semester} SY ${options.schoolYear}\n${options.instituteName}`,
                fontSize: 14,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },
            {
                table: {
                    headerRows: 1,
                    widths: [20, 110, '*', '*', '*', 50, 50, 50],
                    body: tableBody
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => '#000',
                    vLineColor: () => '#000',
                }
            }
        ]
    };

    pdfMake.createPdf(docDefinition).open();
}

function getBase64Image(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = url;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = error => reject(error);
    });
}